class StorageFacade {
    constructor(underlyingStorage) {
        this.underlyingStorage = underlyingStorage;
    }

    clear() {
        this.underlyingStorage.clear();
    }

    getItem(key) {
        return this.underlyingStorage.getItem(key);
    }

    removeItem(key) {
        return this.underlyingStorage.removeItem(key);
    }

    setItem(key, data) {
        return this.underlyingStorage.setItem(key, data);
    }

    addEventListener(listener, useCapture) {
        window.addEventListener('storage', listener, useCapture);
    }
}

export { StorageFacade }


// WEBPACK FOOTER //
// ./src/common/storage/storageFacade.js